/**
 * brand.js — Configuración de marca del frontend.
 * 
 * Valores por defecto que se muestran ANTES de que
 * la API /api/site-config/public/ responda.
 * 
 * En producción, el store Vuex `brand` sobrescribe estos
 * valores con los datos de SiteConfig (DB).
 */

const brand = {
  // Identidad
  storeName: process.env.VUE_APP_STORE_NAME || 'Fix Glass',
  storeSlogan: 'Reparación de celulares y accesorios',
  storeLogoUrl: '',        // Se llena desde la API
  storeLogoAltUrl: '',

  // Contacto (fallback si la API aún no respondió o no hay fila en BD)
  contactEmail: 'fixglass.merlo@gmail.com',
  contactPhone: '1136605055',
  contactWhatsapp: '1136605055',
  whatsappMessage: 'Hola, quisiera consultar por una reparación o accesorio',
  contactAddress: '',

  // Social
  socialInstagram: '',
  socialFacebook: '',
  socialTiktok: '',
  socialTwitter: '',

  // Branding
  primaryColor: '#2563eb',
  secondaryColor: '#1e40af',
  accentColor: '#f59e0b',

  // Comercial
  currency: 'ARS',
  currencySymbol: '$',
  paymentProvider: 'mercadopago',

  // Features
  enableAgeVerification: false,
  enableBlog: true,
  enableDesktopApp: false,
  enableGuestCheckout: true,

  // SEO
  lang: 'es',
  geoRegion: 'AR',

  // Developer
  developerName: '',
  developerUrl: '',
};

export default brand;
